// src/components/ContentViews/ResultsDisplay.js
import React from 'react';
import ResultItem from './ResultItem';
import useExploreStore from '../../contexts/useExploreStore';

const ResultsDisplay = () => {
  const { results } = useExploreStore();

  return (
    <div className="space-y-4">
      {results.map((result) => (
        <ResultItem key={result.id} {...result} />
      ))}
    </div>
  );
};

export default ResultsDisplay;
